import React, {useState, useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';
import api from '../../services/api';
import { toast } from 'react-toastify';
import Modal from '../confirmationModel/ConfirmationModel';

const ProfileForm = ({ onLogoutClick }) => {
    const { user, setUser } = useAuth();
    const [formData, setFormData] = useState({ name: '', address: '', phone_number: '' });
    const [errors, setErrors] = useState({});
    const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);

    // --- PERUBAHAN 1: Tambahkan state untuk mode edit ---
    const [isEditing, setIsEditing] = useState(false);

    useEffect(() => {
        if (user) {
            setFormData({
                name: user.name || '',
                address: user.address || '',
                phone_number: user.phone_number || '',
            });
        }
    }, [user]);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
        if (errors[e.target.name]) {
            setErrors(prev => ({...prev, [e.target.name]: null}));
        }
    };

    const handleOpenConfirmation = (e) => {
        e.preventDefault();
        setErrors({});
        setIsConfirmModalOpen(true);
    };

    const handleConfirmSubmit = async () => {
        setIsConfirmModalOpen(false);
        const toastId = toast.loading("Menyimpan perubahan...");
        try {
            await api.put('/users/me', formData);
            setUser(prevUser => ({ ...prevUser, ...formData }));
            toast.update(toastId, { render: "Profil berhasil diperbarui!", type: "success", isLoading: false, autoClose: 3000 });
            // --- PERUBAHAN 2: Kembali ke mode lihat setelah berhasil menyimpan ---
            setIsEditing(false); 
        } catch (error) {
            if (error.response && error.response.status === 400) {
                const backendErrors = {};
                error.response.data.errors.forEach(err => {
                    backendErrors[err.path] = err.msg;
                });
                setErrors(backendErrors);
                toast.update(toastId, { render: "Gagal, mohon periksa input Anda.", type: "error", isLoading: false, autoClose: 3000 });
            } else {
                toast.update(toastId, { render: "Gagal memperbarui profil.", type: "error", isLoading: false, autoClose: 3000 });
            }
            console.error(error);
        }
    };

    // --- PERUBAHAN 3: Tambahkan fungsi untuk handle tombol Edit dan Batal ---
    const handleEditClick = () => {
        setIsEditing(true);
    };

    const handleCancelClick = () => {
        setIsEditing(false);
        setErrors({}); // Hapus error jika ada
        // Kembalikan data form ke data asli dari user
        setFormData({
            name: user.name || '',
            address: user.address || '',
            phone_number: user.phone_number || '',
        });
    };

    return (
        <>
            <div className="tab-content">
                <h2>Profil Saya</h2>
                {user?.is_verified && (
                    <div className="verified-badge">✅ Akun Terverifikasi</div>
                )}
                <form onSubmit={handleOpenConfirmation}>
                    <div className="form-group">
                        <label>Nama</label>
                        {/* --- PERUBAHAN 4: Tambahkan properti 'disabled' --- */}
                        <input type="text" name="name" value={formData.name} onChange={handleChange} disabled={!isEditing} />
                        {errors.name && <p className="error-text">{errors.name}</p>}
                    </div>
                    <div className="form-group">
                        <label>Alamat</label>
                        <input type="text" name="address" value={formData.address} onChange={handleChange} disabled={!isEditing} />
                        {errors.address && <p className="error-text">{errors.address}</p>}
                    </div>
                    <div className="form-group">
                        <label>Nomor HP</label>
                        <input type="text" name="phone_number" value={formData.phone_number} onChange={handleChange} disabled={!isEditing} />
                        {errors.phone_number && <p className="error-text">{errors.phone_number}</p>}
                    </div>
                    
                    <div className="profile-actions">
                        {/* --- PERUBAHAN 5: Tampilkan tombol secara kondisional --- */}
                        {isEditing ? (
                            <>
                                <button type="submit" className="submit-buttons">Simpan Perubahan</button>
                                <button type="button" onClick={handleCancelClick} className="submit-buttons">Batal</button>
                            </>
                        ) : (
                            <button type="button" onClick={handleEditClick} className="submit-buttons">Edit Profile</button>
                        )}
                        <button type="button" onClick={onLogoutClick} className="logout-button">Logout</button>
                    </div>
                </form>
            </div>

            <Modal
                isOpen={isConfirmModalOpen}
                onClose={() => setIsConfirmModalOpen(false)}
                onConfirm={handleConfirmSubmit}
                title="Konfirmasi Perubahan"
                confirmText="Ya, Simpan"
            >
                Apakah Anda yakin ingin menyimpan perubahan pada profil Anda?
            </Modal>
        </>
    );
};

export default ProfileForm;